
        var result = require("!!../../../../node_modules/css-loader/index.js!./member-list.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/member-list/member-list.component.css
// module id = 611
// module chunks = 0